import { SprintActionTypes } from "./constants";

export const getSprintResponseSuccess = ( actionType = '', data = {} ) => ({
  type: SprintActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const getSprintResponseError = ( actionType = '', error = '' ) => ({
  type: SprintActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getSprintData = ( params ) => {
  return {
    type: SprintActionTypes.GET_SPRINT_DATA,
    payload: { params },
  }
};

export const getSprintDataById = ( params ) => ({
  type: SprintActionTypes.GET_SPRINT_BY_ID,
  payload: params,
});

export const addSprintData = (params) => {
  return {
    type: SprintActionTypes.ADD_SPRINT_DATA,
    payload: params,
  }
};

export const updateSprintData = (params) => ({
  type: SprintActionTypes.UPDATE_SPRINT_DATA,
  payload: params,
});

export const deleteSprintData = (sprint_id) => ({
  type: SprintActionTypes.DELETE_SPRINT_DATA,
  payload: sprint_id,
});

export const resetSprintData = () => ({
  type: SprintActionTypes.RESET_SPRINT_DATA,
  payload: {},
});

export const getSprintReportData = (params) => ({
  type: SprintActionTypes.GET_SPRINT_REPORT_DATA,
  payload: params,
})
